import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'resource#title_voce_onomastica',
  type: 'voce_onomastica',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
      },
    ],
  },
} as ConfigMurucaResourceLayout;
